import React from "react";
import { connect } from "react-redux";
import ReCompra2 from "../../components/Compras/ReCompra";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "../../components/Page";
import Steps from "../../components/Generales/Steps";
import { Row, Col, Alert, } from "reactstrap";
import { FetchDataBancosCuotas, FetchDataRecompraPaquete, limpiarDatosRecompra } from "../../redux/actions/APolizas";
import { limpiarDatosEnvio, listarAccesoriosFetch } from "../../redux/actions/aCotizacion";
import Renovacion from "../../components/Compras/Renovacion";
import { FetchListadoRenovaciones, validarModuloRenovacion } from "../../redux/actions/aLogin";
import { ambienteAplicacion } from "../../constants/urls";
import ErrorPage from "../../components/ErrorPage";

class ContainerRenovacionItem extends React.Component {
  constructor(props) {
    props.limpiarRecompra()
    super(props);



  }

  async componentDidMount() {

    this.props.listarAccesorios();
    this.props.limpiarEnvio()
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');

    let objetoRecompraVacio = {
      "datosAccesorios": {
        "accesorios": [
        ],
        "valorAccesorios": "0"
      }
    }
    await this.props.listarRecompra(idCarrito, null, null, objetoRecompraVacio);
    await this.props.listarBancosCuotas();





    // await this.props.listadoDeRenovaciones(this.props.datosUsuario.brokerCodigo, ambienteAplicacion, idCarrito);

    console.log('this.props.datosUsuario', this.props.datosRenovaciones)

    setTimeout(() => {
      console.log('Compras-Ventas 3222', this.props.datosRenovaciones)
    }, 3000);




  }


  render() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');

    return (
      <main class="cr-app bg-light">
        <div class="cr-content container-fluid">
          <div className="container-body-spaces">

            <LoadingScreen
              loading={
                this.props.datosRecompra.isLoading ||
                this.props.datosBancosCuotas.isLoading
              }

              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Obteniendo datos..."
            >


              <Page
                title={'Resumen renovación'}
                breadcrumbs={[{ name: "Renovación", active: true }]}
              >

                <Row>
                  <Col lg={8} md={12} sm={12} xs={12}>
                    <Steps tipo={'recompra'} activo={'cotizacion'}></Steps>

                  </Col>
                </Row>


                <Alert
                  color="warning"
                  isOpen={(this.props.datosRenovaciones.hasErroredRenovaciones == true && false)}
                >
                  <center>
                    <p>
                      {this.props.datosRecompra.recompraPaqueteError}
                    </p>
                  </center>
                </Alert>



                {

                  validarModuloRenovacion(this.props.datosUsuario.dataUsuario.usu_tipo_usuario) ?
                    <Renovacion
                      datosRecompra={this.props.datosRecompra.recompraPaquete}
                      datosBancos={this.props.datosBancosCuotas.bancosCuotas}
                      idPoliza={idCarrito}

                    /> :

                    <ErrorPage mainText="No tienes permisos para acceder a esta funcionalidad" secondaryText="Por favor, contacta al administrador si crees que esto es un error" />

                }



              </Page>



            </LoadingScreen>



          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({

  datosRecompra: state.dataRecompraPaquete,
  datosBancosCuotas: state.dataBancosCuotas,
  datosRenovaciones: state.dataRenovaciones,
  datosUsuario: state.datosUsuarios,
});

const mapDispatchToProps = (dispatch) => {
  return {

    listarRecompra: (idPoliza, plan, suma, datosAccesorios) => dispatch(FetchListadoRenovaciones(idPoliza, plan, suma, datosAccesorios)),
    listarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
    limpiarRecompra: () => dispatch(limpiarDatosRecompra()),
    limpiarEnvio: () => dispatch(limpiarDatosEnvio()),
    listarAccesorios: () => dispatch(listarAccesoriosFetch()),
    listadoDeRenovaciones: (param, ambiente, id) => dispatch(FetchListadoRenovaciones(param, ambiente, id, null, null)),
  };
};

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerRenovacionItem)